import { createApi } from '@reduxjs/toolkit/query/react';

import { PaginatedResponse } from '../common/dto/common.dto';
import { FeatureViewDto } from '../common/dto/feature.dto';
import { FilterDto } from '../common/dto/filter.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'Feature';

export const featureApi = createApi({
  reducerPath: 'featureApi',
  baseQuery: customFetchBase(`${API_URI}/api/feature`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    searchFeatures: builder.mutation<PaginatedResponse<FeatureViewDto>, Partial<FilterDto>>({
      query(body) {
        return {
          url: ``,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useSearchFeaturesMutation } = featureApi;
